import React, { useState, useRef, useCallback } from "react";
import ReactDOM from "react-dom";
import { withRouter } from "react-router-dom";

import { Avatar } from "@ui5/webcomponents-react/lib/Avatar";
import { Popover } from "@ui5/webcomponents-react/lib/Popover";
import { StandardListItem } from "@ui5/webcomponents-react/lib/StandardListItem";
import { List } from "@ui5/webcomponents-react/lib/List";
import { PlacementType } from "@ui5/webcomponents-react/lib/PlacementType";
import { ShellBar } from "@ui5/webcomponents-react/lib/ShellBar";
import SideDrawer from "./SideDrawer";
import { Button } from "@ui5/webcomponents-react/lib/Button";
/* import ChangePasswordForm from "../../../components/UserSettings/ChangePasswordForm"; */
import "@ui5/webcomponents-icons/dist/icons/menu2.js";
import "@ui5/webcomponents-icons/dist/icons/decline.js";
import "@ui5/webcomponents-icons/dist/icons/nav-back.js";
import "@ui5/webcomponents-icons/dist/icons/employee.js";
import "@ui5/webcomponents-icons/dist/icons/action-settings.js";
import "@ui5/webcomponents-icons/dist/icons/log.js";

import "./MainNavigation.css";

const MainHeader = (props) => {
  const renderButton = () => { 

    if (props.isDrawerOpen) {
      return (
        <Button
          icon="nav-back"
          className="main-navigation__menu-btn"
          onClick={props.drawerHandler.close}
        />
      );
    }else {
      return (
        <Button
          icon="menu2"
          className="main-navigation__menu-btn"
          onClick={props.drawerHandler.open}
        />
      );
    }
  };

/*   const dialogRef = useRef();
  const onOpenChangePwdDialog = useCallback(() => {
    dialogRef.current.open();
  }, [dialogRef]);

  const onCloseChangePwdDialog = useCallback(() => {
    dialogRef.current.close();
  }, [dialogRef]); */

  const popoverRef = useRef();
  const onProfileClick = useCallback(
    (e) => {
      popoverRef.current.openBy(e.detail.targetRef);
    },
    [popoverRef]
  );

  const content = props.isAuthenticated ? (
    <React.Fragment>
      <ShellBar
        logo="//unpkg.com/fundamental-styles/dist/images/sap-logo.png"
        startButton={renderButton()}
        profile={<Avatar icon={'employee'} />}
        onProfileClick={onProfileClick}
      ></ShellBar>
      <Popover
        ref={popoverRef}
        {...{ id: "profile-popover" }}
        placementType={PlacementType.Bottom}
      >
        <List>
          <StandardListItem>{props.user ||''}</StandardListItem>
        </List>
        {/* <List itemClick={onOpenChangePwdDialog}>
          <StandardListItem icon="action-settings">
            Change Password
          </StandardListItem>
        </List> */}
        <List onItemClick={ ()=>{ 
          props.handleLogout();
          }}>
          <StandardListItem icon="log">Logout</StandardListItem>
        </List>
      </Popover>
      {/* <ChangePasswordForm
        dialogRef={dialogRef}
        onCloseChangePwdDialog={onCloseChangePwdDialog}
        user={props.user || ''}
      /> */}
    </React.Fragment>
  ) : (
    <ShellBar logo="//unpkg.com/fundamental-styles/dist/images/sap-logo.png"></ShellBar>
  );

  return ReactDOM.createPortal(content, document.getElementById("header-hook"));
};

const MainNavigation = (props) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const drawerHandler = {
    open(cb) {
      setIsDrawerOpen(true);
    },
    close(cb) {
      setIsDrawerOpen(false);
    },
  };

  const sideBarRedirection = (selectedId) => {
    if (selectedId === "home") {
      props.history.push("/");
    }
    if (selectedId === "approvals") {
      props.history.push("/approvals");
    }
  };

  return (
    <React.Fragment>
      <MainHeader
        {...props}
        isDrawerOpen={isDrawerOpen}
        drawerHandler={drawerHandler}
      />
      {props.isAuthenticated && (
        <SideDrawer
          isDrawerOpen={isDrawerOpen}
          closeDrawer={drawerHandler.close}
          sideBarRedirection={sideBarRedirection}
        />
      )
      }
    </React.Fragment>
  );
};

export default withRouter(MainNavigation);
